import { $t } from '@/i18n';
import { CUSTOM_HOST_CONFIG, EXTERNAL_DEPLOY, HAS_OTHER_AUTH_SERVICE, IS_SHOW_XIAOMAN, IS_SHOW_AEGIS, IS_SHOW_AGENT_REPORT, OPEN_DESIGNER_DEPLOY, OPEN_WUJI_NAVIGATOR, } from '@config/constant';
const projectInfo = $t('k_f73092c');
const version = $t('k_effb261f');
const auth = $t('k_e5f6f1');
const report = $t('k_62caf1cb');
const permission = $t('k_d01cf670');
const setting = $t('k_78539ebc');
export const PAGES = {
    pageList: {
        englishName: ['pageList'],
        name: [$t('k_25bcc5f5')],
        path: '/pagelist',
        keys: {
            addPage: $t('k_3a98802c'),
            labelManage: $t('k_3839254f'),
        },
    },
    basic: {
        englishName: ['projectInfo', 'basic'],
        name: [projectInfo, $t('k_e3c46e83')],
        path: '/basic',
        keys: {
            id: $t('k_f4c7d984'),
            name: $t('k_8828fcda'),
            desc: $t('k_6d2a8848'),
            projectType: $t('k_8fc3cc81'),
            productId: $t('k_c8827c39'),
            admin: $t('k_89b814e7'),
            participant: $t('k_3fb5305c'),
            theme: $t('k_7e42d01e'),
            skin: $t('k_3b2d9eab'),
            navStyle: $t('k_b58f0075'),
            favicon: {
                title: $t('k_1f227f74'),
                desc: $t('k_adc0f26c'),
            },
            homePage: {
                title: $t('k_e229c4dc'),
                desc: $t('k_4a6b04b5'),
            },
            page403: {
                title: $t('k_a98630c'),
                desc: $t('k_a00fcd6d'),
            },
            hideLoadingIndicator: {
                title: $t('k_c955c0dd'),
                desc: $t('k_6d26d2b6'),
            },
            tipsStyle: {
                title: $t('k_e74d3713'),
                desc: $t('k_6d8df820'),
            },
            showWatermark: {
                title: $t('k_5ec25129'),
                desc: $t('k_6c148ff2'),
            },
            xiaoman: {
                title: $t('k_b3ab77c6'),
                desc: [
                    $t('k_1975746f'),
                    $t('k_7d88b15f'),
                    $t('k_262efe35'),
                ],
            },
            aegis: {
                title: $t('k_b58db0f1'),
                desc: [
                    $t('k_22d48703'),
                    $t('k_d8fc33e3'),
                ],
            },
            agentReport: {
                title: $t('k_ddf5b5ce'),
                desc: [
                    $t('k_581b029f'),
                    $t('k_a1a4e2f2'),
                ],
            },
            announcement: {
                title: $t('k_1aef2bf6'),
                desc: $t('k_4537ec7d'),
            },
            customNav: {
                title: $t('k_a1ce8a13'),
                desc: $t('k_334838e7'),
            },
            customSidebar: {
                title: $t('k_7bd7538b'),
                desc: $t('k_f95d97ec'),
            },
            customHeader: {
                title: $t('k_497394ec'),
                desc: $t('k_5971652d'),
            },
            customFooter: {
                title: $t('k_bbf1b556'),
                desc: $t('k_417624d8'),
            },
            visibility: $t('k_5ffa78f0'),
        },
    },
    advance: {
        englishName: ['projectInfo', 'advance'],
        name: [projectInfo, $t('k_60b8cd55')],
        path: '/advance',
        keys: {
            customLayout: $t('k_f4b30c19'),
            routeGuard: $t('k_6dd2204'),
            weworkApp: $t('k_9af4f39a'),
            projectLessCode: $t('k_6830ea57'),
            globalScriptSetting: $t('k_70adca95'),
            globalIcons: $t('k_c71f0afd'),
            aegisConfig: $t('k_e2df3a9b'),
        },
    },
    navbar: {
        englishName: ['navbar'],
        name: [$t('k_f1a19541')],
        path: '/navbar',
        keys: {
            user: $t('k_3988cc00'),
            name: $t('k_fa393bc'),
            projectLogo: $t('k_f820b5d3'),
            env: $t('k_868fb9ab'),
            help: $t('k_3a69a78e'),
            feedback: $t('k_1da199be'),
            wujiNavigator: $t('k_b5030ba1'),
            navFixTop: $t('k_5be772f'),
            showBreadcrumb: {
                title: $t('k_10809af6'),
                desc: $t('k_67139b0a')
                    + $t('k_66db464c'),
            },
            showTagsView: {
                title: $t('k_bb5cc522'),
                desc: $t('k_29589bc5'),
            },
            showNavWaterMark: {
                title: $t('k_195837bc'),
                desc: $t('k_eec2d063'),
            },
            widgets: {
                title: $t('k_16c0c46b'),
                desc: $t('k_475fb85c'),
            },
            bizIsolation: $t('k_caf66673'),
            menuGroup: $t('k_7bf9b398'),
            rightSelect: $t('k_ad9f2f34'),
            navbarComponent: $t('k_933a2fcb'),
            defaultAvatar: $t('k_3eabc597'),
            customAvatar: $t('k_ade06fae'),
            permission: $t('k_2df809bb'),
        },
    },
    sidebar: {
        englishName: ['sidebar'],
        name: [$t('k_c7e1579')],
        path: '/menu',
        keys: {
            width: $t('k_bd1e62a1'),
            menuConfig: $t('k_c063b925'),
            withTitle: $t('k_3dd5ca22'),
            withMenuTitle: $t('k_35790c25'),
            openAllSubMenu: $t('k_85ae821'),
            accordion: {
                title: $t('k_cd400996'),
                desc: $t('k_30d6e973'),
            },
            withSearch: $t('k_f4ca9fba'),
            menuSetting: $t('k_eb778ee1'),
        },
    },
    workflow: {
        englishName: ['workflow'],
        name: [$t('k_93c10ead')],
        path: '/workflow',
        keys: {},
    },
    flow: {
        englishName: ['flow'],
        name: [$t('k_e4aba93f'), $t('k_1d522a5f')],
        path: '/flow',
        keys: {},
    },
    flowJob: {
        englishName: ['job'],
        name: [$t('k_ba4882ab')],
        path: '/flow/job',
        keys: {},
    },
    flowConfig: {
        englishName: ['config'],
        name: [$t('k_e70cbccf')],
        path: '/flow/config',
        keys: {},
    },
    datasource: {
        englishName: ['datasource'],
        name: [$t('k_462caeed')],
        path: '/collection/list',
        keys: {},
    },
    version: {
        englishName: ['version', 'versionRecord'],
        name: [version, $t('k_d321f1c')],
        path: '/version',
        keys: {},
    },
    env: {
        englishName: ['version', 'env'],
        name: [version, $t('k_2b12108c')],
        path: '/env',
        keys: {},
    },
    component: {
        englishName: ['component'],
        name: [$t('k_7e3424ab')],
        path: '/component',
        keys: {},
    },
    offline: {
        englishName: ['offline'],
        name: [$t('k_257d514f')],
        path: '/offline',
        keys: {},
    },
    base: {
        englishName: ['auth', 'base'],
        name: [auth, $t('k_fa6c49f3')],
        path: '/auth/base',
        keys: {
            authApp: $t('k_d2b28cc0'),
            authComponentHub: $t('k_499bf85a'),
        },
    },
    secretKey: {
        englishName: ['auth', 'secretKey'],
        name: [auth, $t('k_6829d7d0')],
        path: '/auth/secretkey',
        keys: {},
    },
    cos: {
        englishName: ['auth', 'projectCOS'],
        name: [auth, $t('k_761886c2')],
        path: '/auth/cos',
        keys: {},
    },
    api: {
        englishName: ['auth', 'apiAuth'],
        name: [auth, $t('k_973832d7')],
        path: '/auth/api',
        keys: {
            setAuthApi: $t('k_cd60b798'),
            authCollectionId: {
                title: $t('k_a7b6ece3'),
                desc: $t('k_e3b361f4'),
            },
            permissionLink: $t('k_9c629ef'),
        },
    },
    dslog: {
        englishName: ['report | dslog', 'dslog'],
        name: [report, $t('k_bc7a0f47')],
        path: '/dslog',
        keys: {},
    },
    role: {
        englishName: ['permission', 'role'],
        name: [permission, $t('k_16a0397a')],
        path: '/permission/role',
        keys: {},
    },
    user: {
        englishName: ['permission', 'user'],
        name: [permission, $t('k_54d7bddb')],
        path: '/permission/user',
        keys: {},
    },
    customPermission: {
        englishName: ['permission', 'customPermission'],
        name: [permission, $t('k_dc0e1e5d')],
        path: '/permission/permission',
        keys: {},
    },
    apiPermission: {
        englishName: ['permission', 'apiPermission'],
        name: [permission, $t('k_97f9a523')],
        path: '/permission/api',
        keys: {},
    },
    permissionAdvanceSetting: {
        englishName: ['permission', 'advanceSetting'],
        name: [permission, $t('k_1f38dc46')],
        path: '/permission/advance',
        keys: {},
    },
    announcement: {
        englishName: ['announcement'],
        name: [$t('k_1aef2bf6'), $t('k_ad86af63')],
        path: '/announcement',
        keys: {},
    },
    branch: {
        englishName: ['branch'],
        name: [$t('k_1bb54a86')],
        path: '/settings/branch',
        keys: {
            enabledBranch: {
                title: $t('k_71363dc9'),
                desc: $t('k_7e903cb4'),
            },
            protectBranch: {
                title: $t('k_666b5a1a'),
                desc: $t('k_6de8fef8'),
            },
            branchRelatedEnv: {
                title: $t('k_4f801b54'),
                desc: $t('k_51558cf0'),
            },
        },
    },
    publish: {
        englishName: ['setting', 'publish'],
        name: [setting, $t('k_9f615023')],
        path: '/settings/publish',
        keys: {
            deleteProject: $t('k_30fd9431'),
            needStaging: {
                title: $t('k_b3183783'),
                desc: $t('k_f6b7caaa'),
            },
            enabledProdVersionApproval: {
                title: $t('k_62dbaf6c'),
                desc: $t('k_282b7d04'),
            },
            devToProd: $t('k_d61c975'),
            pushHook: $t('k_ff732bad'),
        },
    },
    editor: {
        englishName: ['setting', 'editor'],
        name: [setting, $t('k_2e419d63')],
        path: '/settings/editor',
        keys: {
            eslintEnabled: {
                title: $t('k_51b2997'),
                desc: $t('k_ad9b7477'),
            },
            eslintConfig: {
                title: $t('k_21a8cf5f'),
            },
        },
    },
};
export const UPDATE_PAGE = {
    projectUpdate: {
        englishName: ['projectUpdate'],
        name: ['应用更新'],
        path: '/subProject/update',
        keys: {},
    },
};
export const BRANCH_PAGE = {
    branch: {
        englishName: ['branch'],
        name: ['分支管理'],
        path: '/branch',
        keys: {},
    },
};
export const REPORT_PAGE = {
    report: {
        englishName: ['report | dslog', 'report'],
        name: [report, '上报分析'],
        path: '/report',
        keys: {},
    },
};
export const HOST_PAGE = {
    host: {
        englishName: ['setting', 'shortPath'],
        name: [setting, '短路径配置'],
        path: '/settings/host',
        keys: {},
    },
};
export const AUTH_PAGE = {
    AuthSetting: {
        englishName: ['setting', 'AuthSetting'],
        name: [setting, '鉴权设置'],
        path: '/permission/setting',
        keys: {},
    },
};
export const ADVANCE_PAGE = {
    advanceSetting: {
        englishName: ['setting', 'advanceSetting'],
        name: [setting, '其他'],
        path: '/settings/advance',
        keys: {},
    },
};
export const EDITOR_PAGE = {
    advanceSetting: {
        englishName: ['setting', 'editor'],
        name: [setting, '编辑器设置'],
        path: '/settings/editor',
        keys: {},
    },
};
export const EMAIL_SETTING_PAGE = {
    advanceSetting: {
        englishName: ['setting', 'email'],
        name: [setting, '邮箱配置'],
        path: '/settings/email',
        keys: {},
    },
};
export const OPEN_PAGE = {
    openNetwork: {
        englishName: ['setting', 'openNetwork'],
        name: [setting, '外网设置'],
        path: '/settings/open',
        keys: {},
    },
};
// 是否为可以显示的搜索项（如：小满反馈为外网不显示的配置项）
async function isIncludeKey(key, store) {
    const { hasDeptInfoService, isSuper } = await import('@utils/userInfo');
    const basicKeys = PAGES.basic.keys;
    const visibility = store.state.project.projectInfo?.visibility;
    const customLayouts = window.xy_custom_layouts || [];
    if (key === basicKeys.orgName && !hasDeptInfoService())
        return false;
    if (key === basicKeys.visibility && !(isSuper() || visibility === '1'))
        return false;
    if (key === basicKeys.xiaoman.title && !IS_SHOW_XIAOMAN)
        return false;
    if (key === basicKeys.aegis.title && !IS_SHOW_AEGIS)
        return false;
    if (key === basicKeys.agentReport.title && !IS_SHOW_AGENT_REPORT)
        return false;
    if (key === PAGES.navbar.keys.wujiNavigator && !OPEN_WUJI_NAVIGATOR)
        return false;
    if (key === PAGES.advance.keys.customLayout && customLayouts.length <= 0)
        return false;
    return true;
}
export async function searchConfig(input) {
    const result = [];
    const { useStore } = await import('@/store');
    const store = useStore();
    const enabledBranch = store.state.project.settings?.versionSetting?.enabledBranch;
    const haveParent = !!store.state.project.baseProjectInfo?.parentId;
    const needToSearchPages = {
        ...PAGES,
        ...(haveParent ? UPDATE_PAGE : {}),
        ...(enabledBranch ? BRANCH_PAGE : {}),
        ...(!EXTERNAL_DEPLOY ? REPORT_PAGE : {}),
        ...(CUSTOM_HOST_CONFIG ? HOST_PAGE : {}),
        ...(HAS_OTHER_AUTH_SERVICE ? AUTH_PAGE : {}),
        ...ADVANCE_PAGE,
        ...(OPEN_DESIGNER_DEPLOY ? OPEN_PAGE : {}),
    };
    const isMatched = (key) => {
        if (!key)
            return false;
        if (Array.isArray(key)) {
            return key.some(i => i.toLowerCase().includes(input.toLowerCase()));
        }
        return key.toLowerCase().includes(input.toLowerCase());
    };
    for (const page of Object.values(needToSearchPages)) {
        const englishName = page.englishName.join('/');
        const name = page.name.join('/');
        // 搜索一二级菜单
        if (isMatched(name)) {
            result.push({ path: page.path, englishName, chineseName: name, parentMenu: name });
        }
        // 搜索页面配置项
        for (const [key, value] of Object.entries(page.keys)) {
            const { title, desc } = typeof value === 'string' ? { title: value, desc: '' } : value;
            if (await isIncludeKey(title, store) && (isMatched(title) || isMatched(desc))) {
                result.push({ path: page.path, englishName: `${englishName}/${key}`, chineseName: title, parentMenu: `${name}/${title}` });
            }
        }
    }
    return result;
}
